<template>
  <div class="order-detail">
    <account-nav
      :type="'text'"
      :tabValue="'订单详情'"
      :slipper="false"
    ></account-nav>
    <div class="order-loading">
      <div
        v-if="ajaxStatus && ajaxStatus !=-1"
        class="detail-content"
      >
        <div>
          <!-- 订单信息 -->
          <orderInfo
            :detailData="detailData"
            :orderTitle="orderTitle"
            :orderType="orderType"
          ></orderInfo>
        </div>
        <div v-if="Object.keys(addressData).length != 0">
          <!-- 收件人信息 -->
          <addressInfo
            :detailData="detailData"
            :addressData="addressData"
            @showLogisticsDialog="showLogisticsDialog"
            @showAddressDialog="showAddressDialog"
          ></addressInfo>
        </div>
        <div>
          <!-- 商品信息 -->
          <productInfo
            v-if="detailData.productInfo"
            :detailData="detailData"
          ></productInfo>
        </div>
        <div>
          <!-- 结算信息 -->
          <payInfo
            :detailData="detailData"
            :timeStr="timeStr"
          ></payInfo>
        </div>
      </div>
      <error
        :type="'fail'"
        v-if="!ajaxStatus"
        :warning="warning"
        :mainStyles="{'margin-top': '-3%','height': '100%'}"
      ></error>
    </div>
    <logistics-dialog
      ref="logistics"
      v-show="showLogistics"
      :orderId="editData.orderId"
      @closeLogisticsDialog="closeLogisticsDialog"
    ></logistics-dialog>

    <address-dialog
      ref="address"
      :type="'edit'"
      :editData="editData"
      :showAddress="showAddress"
      :sourceType="sourceType"
      @closeAddressDialog="closeAddressDialog"
    ></address-dialog>
  </div>
</template>

<script>
import axios from '~common/assets/js/ocenter-axios.js'
import { Loading } from 'element-ui'
import { getQueryParamValue } from '~common/util/assist.js'
import error from '@/components/sub/error.vue'
import accountNav from '@/components/sub/accountNav.vue'
import logisticsDialog from '@/components/dialog/logisticsDialog.vue'
import addressDialog from '@/components/dialog/addressDialog.vue'
import orderInfo from '@/components/sub/orderInfo.vue'
import addressInfo from '@/components/sub/addressInfo.vue'
import productInfo from '@/components/sub/productInfo.vue'
import payInfo from '@/components/sub/payInfo.vue'
export default {
  name: 'account',
  metaInfo: {
    title: '订单详情'
  },
  components: {
    accountNav,
    logisticsDialog,
    addressDialog,
    error,
    orderInfo,
    addressInfo,
    productInfo,
    payInfo
  },
  data () {
    return {
      showLogistics: false,
      detailData: {},
      addressData: '', // 地址信息
      showAddress: false,
      editData: {
        orderId: '' // 订单id
      },
      logistics: [],
      ajaxStatus: -1, // 订单信息请求状态：-1-未请求，0-请求失败，1-请求成功
      warning: '请求失败,请重试......',
      loadFlag: false,
      loadingInstance: null,
      loadingTimer: null,
      dropLink: '#', // 退费链接
      sourceType: '1', // 订单类型 1-普通订单；2-兑换卡订单; 1-次卡订单
      orderTitle: '订单信息',
      timeStr: '',
      orderType: getQueryParamValue('orderType')
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loading('.order-loading')
      let orderType = getQueryParamValue('orderType')
      let orderNum = getQueryParamValue('orderNum')
      this.sourceType = (orderType == '2' ? '2' : '1') // 订单类型
      this.editData.orderId = orderNum // 订单号
      this.getOrderData(orderType, orderNum)
    })
  },
  watch: {
    loadFlag: function () {
      if (!this.loadFlag) {
        this.loadingInstance.close()
        this.loadingInstance = null
      }
    }
  },
  methods: {
    /*
    * 获取订单数据
    * @orderNum: 订单号
    */
    getOrderData (orderType, orderNum) {
      axios.post(this.Service.Order.getOrderDetail, { orderNum: orderNum }).then((res) => {
        this.loadFlag = false
        clearTimeout(this.loadingTimer)
        if (res.status == 1) {
          console.log(1111, res.data)
          this.$xesLogger.loadMsg({
            pageuid: 'orderDetail',
            coupon_ids: res.data.productInfo.map(item => item.productId).join(),
            couponorder_number_id: res.data.orderInfo.orderNum
          })
          this.ajaxStatus = 1
          this.detailData = res.data
          this.addressData = res.data.addressInfo ? res.data.addressInfo : {}
          this.editData.orderId = res.data.orderInfo.orderNum
          if (this.detailData.orderInfo && this.detailData.orderInfo.orderType == 5) {
            this.orderTitle = '预售订单'
          }
          if (this.detailData.orderInfo && this.detailData.orderInfo.orderType == 5 && this.detailData.presaleOrderInfo.tailTimeStatus == 2 && this.detailData.presaleOrderInfo.tailLeftTime > 0) {
            // 预售订单尾款支付倒计时
            this.countDown(this.detailData.presaleOrderInfo.tailLeftTime)
          }
          // 封装物流查询需要的数据信息；
          if (!this.detailData.expressInfo) return
          const express = this.detailData.expressInfo
          for (let item of this.detailData.expressInfo.logisticsTrace) {
            let obj = {
              logisticsCompany: item.logisticsCompany, // 公司id；
              logisticsNo: item.logisticsNo // 物流单号id
            }
            this.logistics.push(obj)
          }
        } else {
          this.ajaxStatus = 0
          this.warning = res.data
        }
      })
        .catch((err) => {
          clearTimeout(this.loadingTimer)
          this.loadFlag = false
          this.ajaxStatus = 0
          console.log(err)
        })
    },

    loading (selector) {
      let loadTime = 500
      this.loadingTimer = setTimeout(() => {
        this.loadFlag = true
        if (this.loadFlag) {
          this.loadingInstance = Loading.service({
            target: document.querySelector(selector),
            text: '拼命加载中',
            spinner: 'el-icon-loading',
            fullscreen: false,
            background: 'rgba(255, 255, 255, 0.8)',
            customClass: 'loading'
          })
        }
        clearTimeout(this.loadingTimer)
      }, loadTime)
    },

    // 显示物流弹框；
    showLogisticsDialog () {
      this.showLogistics = true
      this.$refs.logistics.showThisDialog(this.editData.orderId)
    },
    // 关闭物流弹框；
    closeLogisticsDialog () {
      this.showLogistics = false
    },

    // 显示 添加／修改地址弹框
    showAddressDialog () {
      this.showAddress = true
      this.$refs.address.addressEdit()
    },

    /*
    * 地址弹框关闭
    * @address 新地址信息，只进行关闭操作 address=false
    */
    closeAddressDialog (address) {
      this.showAddress = false
      if (!address) return
      this.addressData.name = address.name
      this.addressData.phone = `${address.phone.substr(0, 3)}****${address.phone.substr(7, 4)}`
      this.addressData.province_id = address.province_id
      this.addressData.province = address.province_name
      this.addressData.city_id = address.city_id
      this.addressData.city = address.city_name
      this.addressData.county_id = address.county_id
      this.addressData.region = address.county_name
      this.addressData.address = address.recipient_adds || address.detail
    },
    // 预售订单尾款倒计时
    countDown (leftTime) {
      let timer = setInterval(() => {
        leftTime--
        if (leftTime > 0) {
          let dd = Math.floor(leftTime / 60 / 60 / 24)
          let hh = Math.floor((leftTime / 60 / 60) % 24)
          let mm = Math.floor((leftTime / 60) % 60)
          let ss = Math.floor(leftTime % 60)
          this.timeStr = `<strong>${dd}</strong>天<strong>${hh}</strong>小时<strong>${mm}</strong>分<strong>${ss}</strong>秒后结束`
        } else {
          this.timeStr = '尾款支付时间已过'
          this.detailData.operateInfo.operateHref = ''
          clearInterval(timer)
        }
      }, 1000)
    }
  }
}
</script>
<style scoped>
.order-oprate strong {
  color: #f13232;
  font-weight: normal;
}
.detail-content {
  padding: 10px 20px 50px 20px;
  font-size: 12px;
  color: #999;
  /* color: #666666; */
}
</style>



// WEBPACK FOOTER //
// module/order/src/components/OrderDetail.vue